/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CarpsaleManagementListItemRequest = {
    perPage?: number | null;
    page?: number | null;
    keyword?: string | null;
    sort?: string | null;
    direction?: CarpsaleManagementListItemRequest.direction | null;
    sales?: Array<string> | null;
    categoryIds?: Array<string> | null;
    subCategoryIds?: Array<string> | null;
    statuses?: Array<string> | null;
    saleCode?: string | null;
    nameOrCode?: string | null;
    company?: string | null;
    codes?: string | null;
};

export namespace CarpsaleManagementListItemRequest {

    export enum direction {
        ASC = 'asc',
        DESC = 'desc',
    }


}

